//core
import React from 'react';
import { useTranslation } from "react-i18next";
import arePropsEqual from "react-fast-compare";
import { Chip } from "@mui/material";

//icons
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import UndoIcon from '@mui/icons-material/Undo';

//theme
import { Theme } from "@mui/material/styles/createTheme";
import { useTheme } from "@mui/styles";
import {
  lightGreen,
  red,
  blueGrey,
  amber,
  cyan,
  purple,
  indigo,
} from "@mui/material/colors";


interface IBetResultProps {
  value: string;
  prefix?: string;
}

const BetResult: React.FC<IBetResultProps> = ({ value, prefix = '' }): React.ReactElement => {
  const theme: Theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      {!!value ? (
        <>
          {value.toLowerCase() === 'win' && (
            <Chip
              size="small"
              label={!!prefix ? `${t(`${prefix}${value}`)}` : value}
              color="error"
              sx={{backgroundColor: red[500]}}
              icon={<CloseIcon />}
            />
          )}
          {value.toLowerCase() === 'lose' && (
            <Chip
              size="small"
              label={!!prefix ? `${t(`${prefix}${value}`)}` : value}
              color="secondary"
              sx={{backgroundColor: lightGreen[500]}}
              icon={<CheckIcon />}
            />
          )}
          {value.toLowerCase() === 'cashout' && (
            <Chip
              size="small"
              label={!!prefix ? `${t(`${prefix}${value}`)}` : value}
              color="warning"
              icon={<DownloadDoneIcon />}
            />
          )}
          {value.toLowerCase() === 'unknown' && (
            <Chip
              size="small"
              label={!!prefix ? `${t(`${prefix}${value}`)}` : 'Open'}
              color="secondary"
              sx={{backgroundColor: blueGrey[500]}}
              icon={<QuestionMarkIcon />}
            />
          )}
          {value.toLowerCase() === 'deadheat' && (
            <Chip
              size="small"
              label={!!prefix ? `${t(`${prefix}${value}`)}` : value}
              color="secondary"
              sx={{backgroundColor: cyan[500]}}
              icon={<SwapHorizIcon />}
            />
          )}

          {value.toLowerCase() === 'return' && (
            <Chip
              size="small"
              label={!!prefix ? `${t(`${prefix}${value}`)}` : value}
              color="secondary"
              sx={{backgroundColor: purple[500]}}
              icon={<UndoIcon />}
            />
          )}
          {value.toLowerCase() === 'technicalreturn' && (
            <Chip
              size="small"
              label={!!prefix ? `${t(`${prefix}${value}`)}` : value}
              color="secondary"
              sx={{backgroundColor: indigo[500]}}
              icon={<UndoIcon />}
            />
          )}
          {value.toLowerCase() === 'open' && (
            <Chip
              size="small"
              label={!!prefix ? `${t(`${prefix}${value}`)}` : value}
              color="success"
              sx={{backgroundColor: blueGrey[500]}}
            />
          )}
            {value.toLowerCase() === 'closed' && (
             <Chip
              size="small"
              label={!!prefix ? `${t(`${prefix}${value}`)}` : value}
              color="success"
            />
          )}
        </>
      ) : '—'}
    </>
  );
};

export default BetResult;
